import { Component, effect } from '@angular/core';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { INavigationFlatTreenode } from 'src/app/types/infrastructure/interfaces/INavigationFlatTreenode';
import { DataService } from 'src/app/services/data.service';
import { AppstateService } from 'src/app/services/appstate.service';
import { TreeService } from 'src/app/services/controls/tree.service';

@Component({
  selector: 'app-projekte-tree',
  templateUrl: './projekte-tree.component.html',
  styleUrl: './projekte-tree.component.css'
})
export class ProjekteTreeComponent {

  public treeControl = new FlatTreeControl<INavigationFlatTreenode>( node => node.level, node => node.expandable, );
  public dataSource = new MatTreeFlatDataSource(this.treeControl, new MatTreeFlattener(this.treeService.transformTreenodeData, node => node.level, node => node.expandable, node => node.children ));

  constructor(public appStateService: AppstateService,
              private treeService: TreeService, 
              private dataservice: DataService) {

    effect(() => {
      this.dataSource.data = this.dataservice.projekteTreeNodes();
      this.treeControl.expandAll();
    });
  }

  ngOnInit() {
    this.appStateService.projekteTreeInit.set(true);
  }

  hasChild(_: number, node: INavigationFlatTreenode) {
    return node.expandable;
  }

  onClick(treeview: string, value: string) {
    if (treeview == 'projekte') {
      this.appStateService.navigationBereich.set(value);
    } else {
      this.appStateService.navigationBearbeitung.set(value);
    }
  }
}
